var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloseLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 31.1 31.1"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m30 3-2-2-12.5 12.5L3 1 .9 3l12.5 12.5L.9 28 3 30.1l12.5-12.5L28 30.1l2-2.1-12.5-12.5z"
})));
export default SvgCloseLarge;